"use client";

import type { CollapsibleState } from "@/app/[lang]/[workspaceId]/_components/layout/sidebar/types";

// Cookieキー定義
const COLLAPSIBLE_PROJECT_GROUPS_COOKIE_KEY = "collapsible-project-groups";

import { getCookie, setCookie } from "cookies-next";
import {
  BROWSER_ACCESSIBLE_COOKIE_OPTIONS,
  COOKIE_MAX_AGE,
} from "./cookie-options";

const BROWSER_COOKIE_OPTIONS = {
  ...BROWSER_ACCESSIBLE_COOKIE_OPTIONS,
  maxAge: COOKIE_MAX_AGE.ONE_YEAR,
};

/**
 * プロジェクトグループの折りたたみ状態をCookieに保存する
 * @param state
 */
export const setProjectGroupsStateCookie = (state: CollapsibleState) => {
  setCookie(
    COLLAPSIBLE_PROJECT_GROUPS_COOKIE_KEY,
    JSON.stringify(state),
    BROWSER_COOKIE_OPTIONS,
  );
};

/**
 * プロジェクトグループの折りたたみ状態をCookieから取得する
 * @returns
 */
export const getProjectGroupsStateCookie = (): CollapsibleState | null => {
  const cookie = getCookie(
    COLLAPSIBLE_PROJECT_GROUPS_COOKIE_KEY,
    BROWSER_COOKIE_OPTIONS,
  );
  if (typeof cookie === "string") {
    try {
      return JSON.parse(cookie);
    } catch {
      return null;
    }
  }
  return null;
};
